import { render, staticRenderFns } from "./DatePickerField.vue?vue&type=template&id=badc7fc6&scoped=true"
import script from "./DatePickerField.vue?vue&type=script&lang=js"
export * from "./DatePickerField.vue?vue&type=script&lang=js"
import style0 from "./DatePickerField.vue?vue&type=style&index=0&id=badc7fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badc7fc6",
  null
  
)

export default component.exports